<script setup>
import { computed } from 'vue';

const props = defineProps({
  src: { type: String, default: '' },
  alt: { type: String, default: 'Mapa do imóvel' },
  href: { type: String, default: '' },
  aspectClass: { type: String, default: 'aspect-[16/9]' },
});

const rootTag = computed(() => (props.href ? 'a' : 'div'));
</script>

<template>
  <component
    :is="rootTag"
    :href="href || undefined"
    class="block overflow-hidden rounded-lais border border-lais-border bg-lais-bg-soft"
    :class="aspectClass"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img v-if="src" :src="src" :alt="alt" class="h-full w-full object-cover" />
    <div
      v-else
      class="grid h-full w-full place-items-center text-lais-text-muted"
    >
      <span class="i-lucide-map size-6" aria-hidden="true" />
    </div>
  </component>
</template>
